// Reviewer identity persists in localStorage so a guest only enters their
// name + email on the first comment of a session. The dashboard's own
// authenticated owner uses their account info instead — see ProjectDetailPage.

const KEY = "clarity_reviewer";

export type ReviewerIdentity = {
  name: string;
  email: string;
};

export function readReviewer(): ReviewerIdentity | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ReviewerIdentity>;
    if (!parsed.name || !parsed.email) return null;
    return { name: parsed.name, email: parsed.email };
  } catch {
    return null;
  }
}

export function writeReviewer(identity: ReviewerIdentity): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(identity));
  } catch {
    // localStorage may be blocked in some review contexts — fail silent.
  }
}

export function clearReviewer(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
